/**
 * Created by qlong on 10/5/2016.
 */

import React, {Component}  from 'react'
import { Link } from 'react-router'

export default class NavigationLink extends Component{
    render(){
        return(
            <Link className="link"
                  to={this.props.path}
                  activeStyle={{
                      color:'black',
                      fontWeight:'bold',
                  }}
            >{this.props.text}</Link>)
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/NavigationLink.js
 **/